import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as catalogoActions from '../../reducers/catalogoReducer/actions'
import { catalogoDataSelector } from '../../selectors/catalogoSelector'
import * as rubrosActions from '../../reducers/rubrosReducer/actions'
import { rubrosDataSelector } from '../../selectors/rubrosSelector'
import * as articuloActions from '../../reducers/articuloReducer/actions'
import { articuloDataSelector } from '../../selectors/articuloSelector'
import * as Notification from '../../components/Common/notification'
import ArticuloTextilNuevo from '../../components/Articulo/articuloTextilNuevo'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import { usuarioSelector } from '../../selectors/sessionSelector'

class ArticuloTextilNuevoContainer extends React.Component{
    
    constructor(props){
        super(props)

        let model = 1
        if (this.props.location.payloadRubro !== undefined){
            model = this.props.location.payloadRubro
        }
        this.props.sagaGetSubRubros(model,null,true);
        this.props.sagaGetTipotalle();
        let payload = {}
        
        // Haremos una validacion, para ver si traemos, el articulo o el catalogo.
        let idTemporalEdition = 0
        if (this.props.location.idCatalogo !== undefined){
            
            payload.id = this.props.location.idCatalogo
            idTemporalEdition= Math.floor(1000 + Math.random() * 9000)    
            
            //Antes se usaba GetCatalogoCompleto, pero era muchos datos y era innecesario traerlo entero.
            //De ahora en mas, el CatalogoCompleto se usa para la edicion solamente. No llamamos mas a la api 
            //para traer un catalogo. 
        }
        else{
            payload.id = this.props.match.params.idArticulo
            idTemporalEdition= Math.floor(1000 + Math.random() * 9000)    
            payload.idTemporalEdition = idTemporalEdition
            
            if (this.props.match.params.idArticulo !== undefined){
                this.props.sagaGetArticuloCompleto(payload)
            }
            if (this.props.dataCatalogo.catalogoCompleto === undefined){
                this.props.sagaGetCatalogoCompleto({ id: this.props.match.params.idCatalogo })
            }
        }    

        this.state = {
            saved:false,
            errorDescription: {},
            valid: true,
            update:false,
            edicion:false,            
            articulo: {
                nombre: '',
                precio: '',
                idSubrubro: 0,
                idTipoTalle: 0,
                imgSrc: [],
                stock: [],
                codigoInterno: '',
                deletedStocks: []
    
            },
            updateIdTemporal: false,
            idTemporal: idTemporalEdition,
            imagenesCargadas: false,
            cantidadImagenesCargadas: 0,
            cantidadImagenesOriginalesCargadas: 0,
            cantidadImagenesStockCargadas: 0,
            idSubRubroInicial: undefined,

            openModalImagen: false,
            openModalImagenTalleColor: false,
            showBorrarArticuloDialog:false,
            imagenOriginal:undefined,
            imagenTalleColor: undefined,
            currentFiles:{},
            pathRecorteActual: undefined,
            pathTalleColor:undefined,
            indiceTalleColor : undefined,
            idTemporalTalleColor: undefined,
            articuloImagenModal: undefined,

            articuloCargado: false,
            stockOriginal: undefined,
            cantidadLlamadasAtemporal: 0,
            usuarioCargado: false
        }    
    }

    componentDidUpdate = () => {

        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.state.articuloCargado === false){
            this.setState({ articuloCargado: true }, this.guardarStockOriginal)
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.state.imagenesCargadas === false){
            this.setState({ imagenesCargadas: true }, this.getImagenesArticulo)
        }
        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.cantidadImagenesCargadas !== this.state.cantidadImagenesCargadas){
            this.setState({ cantidadImagenesCargadas: this.props.dataArticulo.cantidadImagenesCargadas }, this.actualizarImagenesArticulo)
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.cantidadImagenesOriginalesCargadas !== this.state.cantidadImagenesOriginalesCargadas){
            this.setState({ cantidadImagenesOriginalesCargadas: this.props.dataArticulo.cantidadImagenesOriginalesCargadas}, this.actualizarImaganesOriginalesArticulo)
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.cantidadImagenesStockCargadas !== this.state.cantidadImagenesStockCargadas){
            this.setState({cantidadImagenesStockCargadas: this.props.dataArticulo.cantidadImagenesStockCargadas}, this.actualizarImagenesStock)
        }
    }

    componentWillMount = (props) => {
        if (this.state.articulo !== undefined && this.state.updateIdTemporal == false){
            this.setState({
                updateIdTemporal: true
            })
        }
    }

    componentWillReceiveProps(nextProps){
        
        if (this.state.update === false && nextProps.match.params.idArticulo !== undefined && nextProps.dataArticulo.articuloCompleto !== undefined && nextProps.dataSubrubro.subrubros !== undefined){
            
            let newStock = nextProps.dataArticulo.articuloCompleto.stock
            let imgTemp = nextProps.dataArticulo.articuloCompleto.listaImagenesArticulos
            imgTemp.map(item => {
                if (item.miniatura) item.selected = true
            })
            
            this.setState({
                ...this.state, 
                articulo: {
                    ...this.state.articulo,
                    stock: newStock,
                    imgSrc: imgTemp,
                    nombre: nextProps.dataArticulo.articuloCompleto.nombre,
                    precio: nextProps.dataArticulo.articuloCompleto.precioLista,
                    idSubrubro:  nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.subrubroClass.idSubRubro : 0,
                    idTipoTalle:  nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.tipoTalle.idTipoTalle : 0,
                    codigoInterno: nextProps.dataArticulo.articuloCompleto.codigoInterno
                },
                edicion:true,
                update:true,
                idSubRubroInicial:nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.subrubroClass.idSubRubro : 0,
            })
        }
    }

    guardarStockOriginal = () => {
        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.articuloCompleto.stock){

            let stock = {}
            
            this.props.dataArticulo.articuloCompleto.stock.forEach((s) => {
                s.talle.forEach((t, i) => {
                    stock[t.idTalleColor] = t.qty
                })
            })

            this.setState({
                stockOriginal : stock
            })
        }
    }


    actualizarImagenesStock = () => {

        if(this.props.dataArticulo.articuloCompleto !== undefined){

            let articulo = {...this.state.articulo}

            this.props.dataArticulo.articuloCompleto.stock.forEach((nuevoStock)=>{
                articulo.stock.forEach((s)=>{
                    if(s.listIdTalleColor[0] === nuevoStock.listIdTalleColor[0]){
                        s.imagen = `data:image/ief;base64,${nuevoStock.imagen}`
                    }
                })
            })

            this.setState({
                articulo : articulo
            })
        }
    }

    getImagenesArticulo = () => {
        let articulo = this.props.dataArticulo.articuloCompleto
        // busco los recortes de las imágenes de los articulos
        for(var i=0; i<articulo.listaImagenesArticulos.length; i++){
            
            let idImagen = articulo.listaImagenesArticulos[i].idImagen
            let flag = true
            //Si la imagen ya existe en el reductor seteo flag en false y no se vuelve a pedir
            if(this.props.imagenesArticulo !== undefined ){
                this.props.imagenesArticulo.forEach((ai) => {
                    if(ai.idArticuloImagen === idImagen){
                        flag = false
                    }
                })
            }
            //busco la imagen segun el flag 
            if(flag){
                this.props.sagaGetArticuloImagen({ 
                    idArticuloImagen: articulo.listaImagenesArticulos[i].idImagen, 
                    recorte: true 
                })
            }
        }

        // busco los recortes de las imágenes de stock
        for(var i=0; i<articulo.stock.length; i++){
            let item = articulo.stock[i]

            //if(item.pathImagen && item.imagen === undefined)
                this.props.sagaGetStockImagen({ idTalleColor: item.listIdTalleColor[0], recorte: true })
        }
    }

    actualizarImagenesArticulo = () => {

        if(this.props.dataArticulo.articuloCompleto !== undefined){
            // imagenes recortadas
            let imgTemp = this.props.dataArticulo.articuloCompleto.listaImagenesArticulos

            this.setState({
                ...this.state, 
                articulo: {
                    ...this.state.articulo,
                    imgSrc: imgTemp
                }
            })
        }
        
    }

    actualizarImaganesOriginalesArticulo = () => {

        // imagenes originales
        let myCurrentFiles = {...this.state.currentFiles}
        this.props.dataArticulo.articuloCompleto.listaImagenesOriginalesArticulos.forEach((i)=>{
            if(i.imagen !== undefined && myCurrentFiles[i.path] === undefined)
                myCurrentFiles[i.path] = `data:image/ief;base64,${i.imagen}`
        })

        // articulo imagen a mostrar
        let articuloImagenAMostrar = this.state.articuloImagenModal

        // actualizo el estado
        this.setState({ currentFiles: myCurrentFiles }, () => { this.handleOnOpenCropperModal(articuloImagenAMostrar) })
    }

    getItemStock = (idTipoTalle) => {
       
        let tallesCompleto = this.props.dataArticulo.tipotalle.filter(function (conjuntoTalles) {
            
            return (conjuntoTalles.idTipoTalle === idTipoTalle 
                     )}) // filtro los talles y me quedo con el elegido 

        let talles = tallesCompleto[0].talles.map((e) => Object.assign({}, e))  // le asigno unicamente los detalles de los talles
              
        return {
            idTipo: 2,
            color:'',
            imagen:'',
            talle: [...talles],
            idTemporalStock: Math.floor(1000 + Math.random() * 9000), //idTemporal para la carga de imagenes de stock
            PathImagen:''
        }
    }

    handleCheckboxChange = (i, event) =>{
        
        let  imgSrc = this.state.articulo.imgSrc
        imgSrc[i.i].selected = !this.state.articulo.imgSrc[i.i].selected
        imgSrc[i.i].miniatura = imgSrc[i.i].selected
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.imgSrc = imgSrc;                        
        this.setState({articulo:articulo});
             
    }

    handleOnChangeCodigoInterno = (e) =>{
        let articulo = Object.assign({}, this.state.articulo);
        articulo.codigoInterno = e.target.value.toUpperCase();
        
        let parsed = e.target.value.split(".");//usamos los puntos como delimitadores
        if(e.target.value.length > 0 && parsed.length >=3) 
            if (Number(parsed[2]>0)) articulo.precio = parsed[2];

        this.setState({articulo:articulo});
    }

    handleOnBorrarArticulo = () => {
        this.setState({
            showBorrarArticuloDialog: true
        })
    }

    handleOnCancelarBorrarArticulo = () => {
        this.setState({
            showBorrarArticuloDialog: false
        })
    }

    handleOnBorrarConfirmed = (idArticulo, idCatalogo) => {
        
        let payload = {}
        payload.idArticulo = idArticulo
        payload.idCatalogo = idCatalogo
        
        payload.callback = () => {
            if (this.props.dataArticulo.articuloBorrado !== undefined){
                if(this.props.dataArticulo.articuloBorrado.borrado === true){
                    this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.dataCatalogo.catalogoCompleto.idCatalogo}`) // false
                    Notification.showError('Articulo Borrado')
                }else{
                    Notification.showError(this.props.dataArticulo.articuloBorrado.mensaje)
                }
            }
        }

        this.props.sagaSaveBorrarArticulo(payload)

    }

    onImageCompressed = (currentFile) => {
        
        // genero una URL para el archivo    
        let file = URL.createObjectURL(currentFile)       
        let myCurrentFilesOld = {...this.state.currentFiles}
        // subo la imagen al servidor
        let payload = { 
            currentFile: currentFile, 
            idTemporal: this.state.idTemporal 
        }
        payload.callbackDelete = () => {
            let newState = {...this.state}
            let imagenes = newState.articulo.imgSrc

            newState.articulo.imgSrc = imagenes.filter((i) => {if(i.path !== "original_"+currentFile.name) return i})
            newState.currentFiles =  myCurrentFilesOld
            
            this.setState({newState})
        }
        this.props.sagaSaveArticuloImagen(payload)

        //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
        let newImgSrc = [...this.state.articulo.imgSrc]
        newImgSrc.push({path: "original_"+currentFile.name, pathImagen: file, selected: false, idArticuloImagenes:0, orden: this.state.articulo.imgSrc.length > 0 ? this.state.articulo.imgSrc.length +1 : 1, Miniatura: false})
        
        let myCurrentFiles = {...this.state.currentFiles}
        myCurrentFiles["original_"+currentFile.name] = file


        // actualizo el estado
        this.setState({
            ...this.state, 
            articulo: {
                ...this.state.articulo,
                imgSrc: newImgSrc 
            },
            currentFiles: myCurrentFiles
        })
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {        
        
        //let newImgSrc = [...this.state.articulo.imgSrc]
        
        if (rejectedFiles.length > 0) {
            Notification.showError("Archivo de imagen incompatible.")
        }
        else{
            if (acceptedFiles.length > 0) {
                let cantidadLlamadasAtemporal = this.state.cantidadLlamadasAtemporal
                this.setState({cantidadLlamadasAtemporal: (cantidadLlamadasAtemporal + acceptedFiles.length)})
                // por cada imagen seleccionada
                acceptedFiles.map((item) => {
                    let currentFile = item     
                    
                    // genero una imagen para conocer sus dimesiones
                    let _self = this
                    let img = new Image()
                    img.onload = function () {
                        
                        // comprimo la imagen
                        //let newSize = calculateNewSize(this.width, this.height, 750, 750)
                        let newSize = calculateNewSize(this.width, this.height, 750*2, 1125*2) //*2 para aumentar la calidad
                        compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                    }
                    img.src = URL.createObjectURL(currentFile)
                })
            } 
        }            
    }
    
    checkDuplicateInObject = (propertyName, inputArray) => {
        var seenDuplicate = false,
            testObject = {};
      
        inputArray.map(function(item) {
          var itemPropertyName = item[propertyName];    
          
          if (itemPropertyName in testObject && itemPropertyName !== "" && itemPropertyName !== null) {
            testObject[itemPropertyName].duplicate = true;
            item.duplicate = true;
            seenDuplicate = true;
          }
          else {
            testObject[itemPropertyName] = item;
            delete item.duplicate;
          }
        });
      
        return seenDuplicate;
      }

    validar = () => { //Primiero controlo los aspectos generales del articulo y dsp voy a Stock
        let articulo = {...this.state.articulo}
        let valid = true
        let errorDescription = {}
        
        if (articulo.nombre === '' ){     
                    valid=false
                    errorDescription.errorNombre="Por favor ingrese un nombre válido"
                    
            }
        
            if (articulo.nombre.length > 255 ){     
                valid=false
                errorDescription.errorNombre="Por favor ingrese un nombre válido"
                Notification.showError("Nombre con demasiados caracteres.")
        }    
        
        if (articulo.precio === '' || isNaN(articulo.precio)){
                    valid = false
                    errorDescription.errorPrecio = "Por favor ingrese un precio válido"
                    }

        if (articulo.precio.length > 255){
                    valid = false
                    errorDescription.errorPrecio = "Por favor ingrese un precio válido"
                    Notification.showError("Precio con demasiados caracteres.")
                    }            
        
        if (articulo.idSubrubro === 0){
                        valid = false
                        errorDescription.errorSubrubro = "Por favor ingrese un subrubro"
                        }

        if (articulo.idTipoTalle === 0){
                        valid = false
                        errorDescription.errorTipoTalle = "Por favor ingrese un tipo talle"
                        }            
        
        if (articulo.imgSrc.length === 0){
               
                    valid=false
                    errorDescription.errorImagen="Por favor ingrese al menos una imagen"
                    Notification.showError("Por favor ingrese al menos una imagen")
                    }            
        
        /*if (articulo.stock.length === 0){               
                    valid=false
                    errorDescription.errorCantidadStock="Por favor ingrese al menos un item de stock"       
                    Notification.showError("Por favor ingrese al menos un item de stock")             
                    }*/
        
        if (articulo.codigoInterno !== null && articulo.codigoInterno.length > 255){
                    valid = false
                    errorDescription.codigoInterno = "Por favor ingrese un código interno válido"
                    Notification.showError("Código interno con demasiados caracteres.")
                    }              


        //Controlando todos los stocks

        let isDuplicated = this.checkDuplicateInObject('color', articulo.stock) //Checkeo colores repetidos
        
        if (isDuplicated) {
            valid = false
            errorDescription.colorRepetido = "Color repetido, por favor reingrese"
            Notification.showError("Color repetido, por favor reingrese.")
        }

        articulo.stock.map((item, i) => {
               
                if (item.idTipo === 0){
                    
                        valid=false
                        errorDescription.errorColorImagen="Ingrese al menos un tipo (Color/Imagen) en los stock"                        
                        }
                 
                if (item.idTipo === 1 && item.color === ''){
                 
                        valid=false
                        errorDescription.errorColorStock="Por favor ingrese un color válido en los stock"
                        Notification.showError("Por favor ingrese un color válido en los stock")
                 }
                    
                if (item.idTipo === 2 && item.imagen === ''){
                    
                        valid=false
                        errorDescription.errorImagenStock="Por favor ingrese una imagen válida en los stock"                        
                        Notification.showError("Por favor ingrese una imagen válida en los stock")    
                    }    
        
        let counterEmpty = 0 
        let excesoCaracteres = 0               
        articulo.stock[i].talle.map((talleItem, j) => {//Ahora recorro cada talle dentro de los stocks                
               
                if (talleItem.qty === undefined || talleItem.qty === ''){
                    counterEmpty = counterEmpty +1
                    
                }

                if (talleItem.qty !== undefined && talleItem.qty.length > 255){
                    counterEmpty = counterEmpty +1
                    excesoCaracteres = excesoCaracteres +1
                }

                if (excesoCaracteres > 0 ){ 
                    valid= false
                    Notification.showError("Stock con exceso de caracteres")  
                }

                if (counterEmpty === articulo.stock[i].talle.length){
                    
                        valid=false
                        errorDescription.errorNumeroStock="Ingrese un número válido."
                }
            })
        })
        
        articulo.stock.map((item, i) => {
            item.talle.map((talleItem, j) => {
                if (talleItem.qty === undefined || talleItem.qty === ''){
                    talleItem.qty = 0
                }
            })
        })
        this.setState({articulo:articulo})
        
        return {valid, errorDescription}

    }

    

    handleOnChangeOrderArticuloImagenes = (from,to) =>{
       

        let articulo = {...this.state.articulo} 
        let aux = to
        let auxImg = articulo.imgSrc[to]
        articulo.imgSrc[to] = articulo.imgSrc[from]
        articulo.imgSrc[from] = auxImg
        articulo.imgSrc[to].orden = aux + 1 //orden es 1 indice mayor al indice del arreglo, ya que el array empieza en 0
        articulo.imgSrc[from].orden = from + 1
        
        this.setState({
            articulo:articulo
        })
    }
    

    handleOnSave = () => {

       let valido = this.validar()
       if (valido.valid == false){
           this.setState({
               valid:false,
               errorDescription:valido.errorDescription,

           })
       }
       else {
        this.setState({
            valid:true,
            errorDescription:''
        })        
        this.handleSaveConfirmation()
       }
       
    }

    handleSaveConfirmation = () => {
       
        let datosRubro = this.getIdRubroDeUnSubRubro(this.state.articulo.idSubrubro) //this.props.dataSubrubro.rubros[0].idRubro
        
        // genero el payload
        let articuloAlta = {
            IdCatalogo: this.props.dataCatalogo.catalogoCompleto !== undefined ? this.props.dataCatalogo.catalogoCompleto.idCatalogo : this.props.location.idCatalogo,
            IdArticulo: this.props.dataArticulo.articuloCompleto !== undefined ? this.props.dataArticulo.articuloCompleto.idArticulo : 0, //para el alta
            IdInstalacion: 3,
            IdRubro: datosRubro,
            IdSubrubro: this.state.articulo.idSubrubro,
            Nombre: this.state.articulo.nombre,
            PrecioLista: this.state.articulo.precio,
            codigoInterno : this.state.articulo.codigoInterno,
            FechaRegistro: this.state.edicion === true ? this.props.dataArticulo.articuloCompleto.fechaRegistro : new Date(),
            UsuarioRegistro: 'b242a843-e91e-4c65-970a-f4b6747485fc',
            Activo: 1,
            IdTipoTalle: this.state.articulo.idTipoTalle,
            ArticuloImagenes : this.state.articulo.imgSrc,
            Stock :this.state.articulo.stock,
            DeletedStocks: this.state.articulo.deletedStocks,
            idTemporal: this.idTemporalEdition !== undefined ? this.idTemporalEdition :  this.state.idTemporal,
            afterSaveArticulo: this.afterSaveArticulo,
            stockOriginal: this.state.stockOriginal !== undefined ? this.state.stockOriginal : null
        }

        
        //Elimino las imagenes tallerColor del estado del reductor, para luego traer las nuevas cuando se selecciones un articulo
        /*if(this.state.articulo.stock !== undefined ){
            let listaIdTalleColor = []
            this.state.articulo.stock.forEach((s) => {
                s.listIdTalleColor.forEach((tc) => {
                    listaIdTalleColor.push(tc)
                });
            });

            this.props.eliminarImagenTalleColor(listaIdTalleColor)
        }*/
        
        // guardamos el articulo
        this.props.sagaSaveArticulo(articuloAlta)
        
        // si el usuario modificó el subrubro del articulo actualizo el catalogoCompleto en el reductor
        if(this.state.idSubRubroInicial !== undefined && articuloAlta.IdSubrubro !== this.state.idSubRubroInicial){
            let subRubroNuevo 
            this.props.dataSubrubro.subrubros.forEach((s) => {
                if(s.idSubrubro === articuloAlta.IdSubrubro){
                    subRubroNuevo = s
                }
            })
            let payload = {
                idArticulo: articuloAlta.IdArticulo,
                subRubroNuevo: subRubroNuevo
            }
            this.props.cambiarArticuloDeSubRubro(payload)
        }
    }

    getIdRubroDeUnSubRubro = (idSubRubro) => {
        let idRubro = 0 

        if(this.props.dataSubrubro.subrubros !== undefined){
            this.props.dataSubrubro.subrubros.forEach((s) => {
                if(s.idSubrubro === idSubRubro){
                    idRubro = s.idRubro
                }
            })
        }

        return idRubro
    }

    afterSaveArticulo = () => {
        
        // actualizo el estado
        this.setState({
            saved:true,
            valid:true
        })

         //Tratar de hacer un get catalgo completo pero para uno auxiliar
        if (this.props.dataArticulo.articuloCompleto === undefined){
            this.props.sagaGetCatalogoCompleto({id:this.props.match.params.idCatalogo} )
        }

        // muestro mensaje de éxito
        if (this.props.dataArticulo.articuloCompleto !== undefined)
        {
            Notification.showSuccess("Artículo modificado exitosamente")
            if (this.props.dataCatalogo.catalogoCompleto.idCatalogo != 0)
            {
                this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.dataCatalogo.catalogoCompleto.idCatalogo}`)///${this.props.dataArticulo.articuloCompleto !== undefined ? this.props.dataArticulo.articuloCompleto.idArticulo : true}`)
                this.props.setArticuloCompleto(undefined)
            }
            else
            {
                this.props.history.push("/Articulo")
            }
            //seteo articulo completo en undefined por problemas de setstate(ya que hacer al hacer click en otro articulo muchas veces quedaba cargado el anterior)            
        }
        else
        {
            Notification.showSuccess("Artículo agregado exitosamente")
            this.limpiarFiltros()
        }
    }

    limpiarFiltros = () => {        
        let articulo = {...this.state.articulo}
        articulo.nombre = ''
        articulo.precio= ''
        articulo.stock = []
        articulo.imgSrc = []
        articulo.codigoInterno = ''
        //articulo.idSubrubro = ''
        //articulo.idTipoTalle = ''
        this.setState({
            articulo:articulo
        })
    }
    

    handleAddStockItem = idTipoTalle => {
        
        if(idTipoTalle !== 0){

        let newItemStock = this.getItemStock(idTipoTalle)        
        let newState = { ...this.state }
        newState.articulo.stock.push(newItemStock)
        this.setState(newState)
        }
        else{
            Notification.showError("Seleccione un Tipo Talle válido")
        }    
    }

   

    handleArticuloNombre = (nombre) =>{
        
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.nombre = nombre;                        
        this.setState({articulo:articulo});
    }

    handleArticuloPrecio = (precio) =>{
        
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.precio = precio;                        
        this.setState({articulo:articulo});
    }

    handleArticuloIdSubrubro = (idSubrubro) =>{
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.idSubrubro = idSubrubro;                        
        this.setState({articulo:articulo});
    }

    handleArticuloStockTipo = (idTipo,index) =>{
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.stock[index].idTipo = idTipo;

        if (idTipo == '1') {
            articulo.stock[index].PathImagen = ''
            articulo.stock[index].imagen = ''
        }
        if(idTipo ==2){
            articulo.stock[index].color = ''
        }                        
        this.setState({articulo:articulo});
    }

    handleArticuloIdTipoTalle = (idTipoTalle) =>{
        
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.idTipoTalle = idTipoTalle;                        
        this.setState({articulo:articulo});
    }

    
    handleStockColor = (color, index) =>{
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.stock[index].color = color.hex;                        
        this.setState({articulo:articulo});
    }

    handleStockImagen = (imagen, index) =>{
        //let articulo = Object.assign({}, this.state.articulo);
        let file = URL.createObjectURL(imagen.target.files[0])        
        //imagen.target.value = null;       
        let payload = {currentFile: imagen.target.files[0], idTemporal: this.state.articulo.stock[index].idTemporalStock}
        //this.props.sagaSaveArticuloImagenTallecolor(payload)

        //articulo.stock[index].imagen = file;
        //articulo.stock[index].PathImagen = imagen.target.files[0].name       

        this.setState({
            //articulo:articulo,
            openModalImagenTalleColor: true,
            imagenTalleColor:file,
            pathTalleColor:imagen.target.files[0].name,
            indiceTalleColor: index,
            idTemporalTalleColor: payload.idTemporal
        });
    }

    handleStockDelete = (index) =>{
        let articulo = Object.assign({}, this.state.articulo);                                  
        let stockItems = this.state.articulo.stock
        
        let deletedStocks = this.state.articulo.deletedStocks
        deletedStocks.push(stockItems[index].listIdTalleColor)

        
        stockItems.splice(index,1)
        articulo.stock = stockItems
        articulo.deletedStocks = deletedStocks
        this.setState ({
          articulo:articulo
      })
    }

    onChangeCantidad = (e,indexTalle,indexStock) =>{
        let articulo = { ...this.state.articulo }
        let qty = e.target.value                                                 
        articulo.stock[indexStock].talle[indexTalle].qty = qty
        
        this.setState ({
          articulo:articulo
      })
    }

    handleCloseErrorMsg = () => {
        this.setState({
            saved:false,
            valid:true
            
        })
    }

    handleOnCancel = () => {
        this.props.setArticuloCompleto(undefined)
        if (this.props.dataCatalogo.catalogoCompleto != undefined && this.props.dataCatalogo.catalogoCompleto.idCatalogo != 0)
            this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.dataCatalogo.catalogoCompleto.idCatalogo}`)
        else
            this.props.history.push(`/Articulo/`)        
    }

    handleOnCloseCropperModal = () => {
        if(this.state.openModalImagenTalleColor){
            this.setState({openModalImagenTalleColor:false})
        }else this.setState({openModalImagen:false})
    }

    handleOnOpenCropperModal = (articuloImagen) => {
        
        if(articuloImagen === undefined)
            return

        // trato de recuperar la imagen original
        let imgPath = articuloImagen.path
        let position = imgPath.search("original_")
        let imagen 
        let pathRecorteActual = imgPath
        
        if(position === 0){
            imagen = this.state.currentFiles[imgPath]
        }
        else
        {
            let path = 'original_' + imgPath
            pathRecorteActual = path
            imagen = this.state.currentFiles[path]
        }

        // si aún no recuperamos la imagen original, la busco
        if(imagen === undefined)
        {
            // // evito llamadas recursivas
            // if(this.state.articuloImagenModal !== undefined){
            //     Notification.showError('Error al recuperar la imagen')

            //     this.setState({ articuloImagenModal: undefined })
            //     return
            // }

            this.props.sagaGetArticuloImagen({ 
                idArticuloImagen: articuloImagen.idImagen, 
                recorte: false 
            })

            // guardo el artículo imagen a mostrar cuando se recupere la imagen original
            this.setState({ articuloImagenModal: articuloImagen })
        }

        // muestro el modal
        else
        {
            this.setState({
                openModalImagen: true,
                imagenOriginal: imagen,
                pathRecorteActual: pathRecorteActual
            })
        }
    }

    handleClickMenuImagenArticulo = () => {
    }

    handleCloseMenuImagenArticulo = () => {
    }

    handleEliminarImagenArticulo = (indice) => {
        
        //Guardo el articulo en una variable
        let articulo = {...this.state.articulo}
        let imagenes = []
        //Armo arreglo de imagenes sin la imagen a eliminar
            for(let i=0; i < articulo.imgSrc.length; i++){
                if(i !== indice){
                    imagenes.push(articulo.imgSrc[i])
                }
            }
            //seteo el nuevo arregle de imagenes al articulo
            articulo.imgSrc = imagenes
            //guardo el estadol
            this.setState({ 
                articulo: articulo,
            })
    }

    onTalleColorImagenCompressed = (currentFile) => {
        
        // guardo el recorte en temporal
        let payload = {}
        payload.file = currentFile
        payload.idTemporal = this.state.idTemporalTalleColor

        this.props.sagaSaveTalleColorImagenRecorte(payload)

        // genero una URL para el recorte
        let recorte = URL.createObjectURL(currentFile)

        // actualizo el artículo
        let articulo = {...this.state.articulo}
        articulo.stock[this.state.indiceTalleColor].imagen = recorte
        articulo.stock[this.state.indiceTalleColor].PathImagen = this.state.pathTalleColor
        
        // actualizo el estado
        this.setState({
            openModalImagenTalleColor:false,
            articulo: articulo,
            imagenTalleColor:undefined,
            pathTalleColor:undefined,
            indiceTalleColor: undefined,
            idTemporalTalleColor: undefined
        })
    }

    onArticuloImageCompressed = (currentFile) => {
        //IMAGEN ARTICULO
        let payload = {}
        payload.file = currentFile
        payload.idTemporal = this.state.idTemporal 
        payload.callback = () => {
            // genero una URL para el recorte y el nombre del archivo
            let recorte = URL.createObjectURL(currentFile)
            let path = this.state.pathRecorteActual.split('original_')

            //actualizo el articulo colocando el recorte en lugar de la imagen/recorte anterior 
            let newImgSrc = [...this.state.articulo.imgSrc]
            newImgSrc.forEach((i)=>{
                if(i.path === this.state.pathRecorteActual)
                {
                    i.path = path[1]
                    i.pathImagen = recorte
                }
                else
                {
                    if(i.Path === path[1] || i.path === path[1]){
                        i.path = path[1]
                        i.pathImagen = recorte
                    }
                }
            })

            //seteo el recorte al estado y cierro modal
            this.setState({
                ...this.state, 
                articulo: {
                    ...this.state.articulo,
                    imgSrc: newImgSrc 
                },
                openModalImagen: false,
            });
        }
        
        //guardo recorte en temporal
        this.props.sagaSaveArticuloImagenRecorte(payload)

        this.setState({
            openModalImagen: false,
        });
    }

    handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
        
        //IMAGEN TALLECOLOR
        if(this.state.openModalImagenTalleColor)
        {
            // obtengo el nombre de archivo
            let fileName = this.state.pathTalleColor

            // comprimo la imagen
            let newSize = calculateNewSize(imageData.width, imageData.height, 150, 150)
            compress(blobData, fileName, newSize.width, newSize.height, this.onTalleColorImagenCompressed)
        }

        else
        {
            // obtengo el nombre de archivo
            let fileName = this.state.pathRecorteActual.split('original_')[1]

            // comprimo la imagen
            //let newSize = calculateNewSize(imageData.width, imageData.height, 350, 525)
            let newSize = calculateNewSize(imageData.width, imageData.height, 350*2, 525*2) // el *2 es para aumentar la calidad
            
            //tomo el blob
            fetch(recorte)
            .then(r => r.blob())
            .then(r=>{compress(r, fileName, newSize.width, newSize.height, this.onArticuloImageCompressed)})
        }
    }

    render() {
        
        return ( 

                <ArticuloTextilNuevo    
                    subrubros= {this.props.dataSubrubro.subrubros} 
                    tipotalle = {this.props.dataArticulo.tipotalle} 
                    handleAddStockItem= {this.handleAddStockItem}                                         
                    handleOnDropFile = {this.handleOnDropFile}                                        
                    handleCheckboxChange = {this.handleCheckboxChange}
                    handleOnSave = {this.handleOnSave}
                    handleArticuloNombre = {this.handleArticuloNombre}
                    handleArticuloPrecio = {this.handleArticuloPrecio}
                    handleArticuloIdSubrubro = {this.handleArticuloIdSubrubro}
                    handleArticuloIdTipoTalle = {this.handleArticuloIdTipoTalle}
                    handleArticuloStockTipo = {this.handleArticuloStockTipo}
                    handleStockColor = {this.handleStockColor}
                    handleStockImagen = {this.handleStockImagen}
                    handleStockDelete = {this.handleStockDelete}
                    handleOnBorrarArticulo = {this.handleOnBorrarArticulo}
                    handleOnChangeCodigoInterno = {this.handleOnChangeCodigoInterno}
                    onChangeCantidad = {this.onChangeCantidad}
                    valid = {this.state.valid}
                    errorDescription = {this.state.errorDescription}
                    articulo = {this.state.articulo}
                    saved = {this.state.saved}
                    handleOnClose = {this.handleCloseErrorMsg}
                    infoCatalogo = {this.props.location.payloadCatalogo}
                    idCatalogo = {this.state.edicion ? this.props.dataCatalogo.catalogoCompleto : this.props.location.idCatalogo}
                    catalogoNombre = {this.props.location.payloadCatalogoNombre}
                    catalogo = {this.props.dataCatalogo.catalogoCompleto}
                    handleOnCancel = {this.handleOnCancel} 
                    edicion = {this.state.edicion} 
                    articuloEdicion = {this.props.dataArticulo.articuloCompleto}

                    openModalImagen = {this.state.openModalImagen}
                    openModalImagenTalleColor = {this.state.openModalImagenTalleColor}
                    handleOnCloseCropperModal={this.handleOnCloseCropperModal}
                    handleOnOpenCropperModal={this.handleOnOpenCropperModal}
                    handleOnSaveImagenCortada={this.handleOnSaveImagenCortada}
                    imagenOriginal={this.state.imagenOriginal}
                    imagenTalleColor={this.state.imagenTalleColor}
                    showBorrarArticuloDialog = {this.state.showBorrarArticuloDialog}
                    handleOnCancelarBorrarArticulo = {this.handleOnCancelarBorrarArticulo}
                    handleOnBorrarConfirmed = {this.handleOnBorrarConfirmed}
                    handleOnClickEditar = {this.handleOnClickEditar}
                    handleOnChangeOrderArticuloImagenes = {this.handleOnChangeOrderArticuloImagenes}

                    handleClickMenuImagenArticulo={this.handleClickMenuImagenArticulo}
                    handleCloseMenuImagenArticulo={this.handleCloseMenuImagenArticulo}
                    handleEliminarImagenArticulo={this.handleEliminarImagenArticulo}

                    canSave = {this.props.dataArticulo.contadorImagenesEnviadasAtemporal === this.state.cantidadLlamadasAtemporal ? true : false}
                />
        )
    
    }


}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...rubrosActions,
        ...articuloActions,
        ...catalogoActions,      
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        dataSubrubro: rubrosDataSelector(state),
        dataArticulo: articuloDataSelector(state),
        dataCatalogo: catalogoDataSelector(state),
        imagenesArticulo: state.articuloReducer.getIn(["data", "articuloImagenes"]).toJS(),
        usuario: usuarioSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticuloTextilNuevoContainer)